import { render, staticRenderFns } from "./UpdateViewSlots.vue?vue&type=template&id=17fc07e8"
import script from "./UpdateViewSlots.vue?vue&type=script&lang=js"
export * from "./UpdateViewSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports